<template>
  <vx-card class="mb-4" title="Taste Panel">
    <div>
      <div class="vx-row">
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">Search</label>
          <vs-input type="text" class="w-full" v-model="filters['search']" />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">Assigned Staff</label>
          <v-select
            :clearable="true"
            placeholder=""
            multiple
            v-model="filters['user-ids']"
            :reduce="(staff) => staff.value"
            :options="staffs"
            label="name"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          ></v-select>
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select
            :clearable="true"
            v-model="filters['status']"
            :options="['To Do', 'In Progress','Completed']"
            label="status"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          ></v-select>
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">From</label>
          <flat-pickr
            class="w-full"
            :config="{ dateFormat: 'd/m/Y' }"
            v-model="filters['from']"
            placeholder="Choose Date"
          />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">To</label>
          <flat-pickr
            class="w-full"
            :config="{ dateFormat: 'd/m/Y' }"
            v-model="filters['to']"
            placeholder="Choose Date"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-6/6">
          <vs-button
            class="float-right mr-4 mb-2"
            size="small"
            color="danger"
            type="border"
            icon-pack="feather"
            v-on:click="filters = {}"
            >CLEAR</vs-button
          >
        </div>
      </div>
    </div>
    <template slot="actions">
      <vs-button
        class="mr-4"
        @click="onCLickCreateTestPanel"
        color="primary"
        type="filled"
        v-can="'create-edit-quality-control-tastings'"
        >Create Taste Panel</vs-button
      >
    </template>
    <vs-table
      stripe
      :data="tasteGroupList"
      :sst="true"
      class="table-dark-inverted table-auto vs-con-loading__container"
      id="mass-balance-audit-table"
    >
      <template slot="thead">
        <vs-th width="10%">TASTE PANEL CODE</vs-th>
        <vs-th width="20%">BATCH CODE</vs-th>
        <vs-th width="20%">WO CODE</vs-th>
        <vs-th width="10%">CREATED BY</vs-th>
        <vs-th width="10%">CREATED AT</vs-th>
        <vs-th width="10%">ASSIGNED STAFF</vs-th>
        <vs-th width="10%">STATUS</vs-th>
        <vs-th v-can="'create-edit-quality-control-tastings'" width="10%">ACTION</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="(tr, indextr) in data" :key="indextr">
          <vs-td>
            {{ tr.code }}
          </vs-td>
          <vs-td>
            <span v-if="tr.raw_material_stock_inventories.length">
              <span
                v-for="(item, index) in tr.raw_material_stock_inventories"
                :key="item.id"
              >
                <HyperLink
                  :id="
                    item.staff_raw_material_order_item
                      .staff_raw_material_order_id
                  "
                  type="raw-material-order"
                >
                  {{ item.code }}
                </HyperLink>

                <span
                  v-if="index < tr.raw_material_stock_inventories.length - 1"
                >
                  ,
                </span>
              </span>
            </span>

            <span v-else>-</span>
          </vs-td>
          <vs-td>
            <span v-if="tr.work_orders.length">
              <span v-for="(item, index) in tr.work_orders" :key="item.id">
                <HyperLink :id="item.id" type="work-order">
                  {{ item.work_order_code }}
                </HyperLink>

                <span v-if="index < tr.work_orders.length - 1"> , </span>
              </span>
            </span>

            <span v-else>-</span>
          </vs-td>

          <vs-td>
            {{ tr.created_by.name }}
          </vs-td>
          <vs-td>
            {{ __dateTimeFormatterToDate(tr.created_at) }}
          </vs-td>
          <vs-td>
            {{ tr.staff.map((staff) => staff.name).join(" , ") }}
          </vs-td>
          <vs-td>
            {{ getTastePanelStatus(tr) }}
          </vs-td>
          <vs-td v-can="'create-edit-quality-control-tastings'">
            <div class="vx-row">
              <vx-tooltip
              v-if="getTastePanelStatus(tr) !== 'Completed'"
                class="text-primary cursor-pointer mr-2"
                text="View/Update"
                position="top"
              >
                <vs-button
                  @click.stop="onCLickViewTestPanel(tr.id)"
                  size="small"
                  icon-pack="feather"
                  icon="icon-eye"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip
                class="text-primary cursor-pointer mr-2"
                text="Show Result"
                position="top"
              >
                <vs-button
                  @click.stop="onClickShowResult(tr.id)"
                  size="small"
                  color="warning"
                  icon-pack="feather"
                  icon="icon-bar-chart-2"
                ></vs-button>
              </vx-tooltip>
              <vx-tooltip
                class="text-primary cursor-pointer mr-2"
                text="Export Pdf"
                position="top"
              >
                <vs-button
                  @click.stop="onClickExportPdf(tr.id)"
                  size="small"
                  color="danger"
                  icon-pack="feather"
                  icon="icon-download"
                ></vs-button>
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <TastingGroupCreate ref="tastingGroupCreate" @refresh="refresh" />
    <ShowUserTastingFormsList ref="showUserTastingFormsList" />
    <ShowTastePanelResultPopUp ref="showTastePanelResultPopUp" />
    <vs-pagination
      v-on:changeMaxItems="changePage"
      :size-array="meta.total ? meta.total : 20"
      :max-items="perPage"
      description-body="Rows per page"
      description-connector="of"
      description-title="Records"
      description
      :description-items="descriptionItems"
      :total="meta.last_page ? meta.last_page : 0"
      v-model="page"
      class="p-5"
    >
    </vs-pagination>
  </vx-card>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import ErrorMessages from "@/mixins/ErrorMessages";
import Filter from "@/mixins/filter";
import TastingGroupCreate from "@/components/popups/TastePanel/TastingGroupCreate.vue";
import ShowUserTastingFormsList from "@/components/popups/TastePanel/ShowUserTastingFormsList.vue";
import ShowTastePanelResultPopUp from "@/components/popups/TastePanel/ShowTastePanelResultPopUp.vue";

const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
const DropDownRepository = RepositoryFactory.get("drop_down");

export default {
  name: "TastePanelTable",
  data() {
    return {
      meta: {},
      maxItems: 20,
      page: 1,
      total: 0,
      sort: "",
      perPage: defaultPagination,
      descriptionItems: perPageList,
      filters: {},
      tasteGroupList: [],
      statusList: [],
      staffs: [],
    };
  },
  components: {
    flatPickr,
    "v-select": vSelect,
    TastingGroupCreate,
    ShowUserTastingFormsList,
    ShowTastePanelResultPopUp,
  },
  async mounted() {
    await this.getTestGroupList();
    await this.getTastingGroupStatus();
    await this.fetchStaffList();

    const { create, open, type } = this.$route.query;
    if (create) {
      this.onCLickCreateTestPanelwithCode(create, type);
    }
    if (open) {
      this.onCLickViewTestPanel(open);
    }
    if (create || open) {
      this.$router.replace({
        path: this.$route.path,
      });
    }
  },
  mixins: [ErrorMessages, Filter],
  methods: {
    refresh() {
      this.getTestGroupList();
    },
    async getTestGroupList() {
      try {
        this.$vs.loading()
        const response = await TriangleTestsRepository.getListOfTastingGroups(
          this.filterQuery,
          this.page,
          this.perPage
        );
        this.tasteGroupList = response.data.data;
        this.meta = response.data.meta;
      } catch (e) {} finally {
        this.$vs.loading.close()
      }
    },
    async fetchStaffList(){
        this.$vs.loading()
        const {data} = await DropDownRepository.getStaffList()
        this.staffs = data.data.map((x) => ({ name: x.name, value: x.id }))
        this.$vs.loading.close()
    },
    onClickShowResult(id) {
      this.$refs.showTastePanelResultPopUp.openPopUp(id);
    },
    async getTastingGroupStatus() {
      try {
        this.$vs.loading();
        const response = await TriangleTestsRepository.getListOfGroupStatuses();
        this.statusList = response.data.data;
      } catch (e) {
      } finally {
        this.$vs.loading.close();
      }
    },
    async onClickExportPdf(id) {
      try {
        this.$vs.loading();
        const response = await TriangleTestsRepository.exportTastingGroupPdf(
          id
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `tasting-group-${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.convertAndNotifyError(e);
      } finally {
        this.$vs.loading.close();
      }
    },
    onClickViewUserTastingFormsList(dataSet, group_id) {
      this.$refs.showUserTastingFormsList.openPopup(dataSet.id, group_id);
    },
    getBatchCodes(tr) {
      return tr.raw_material_stock_inventories
        .map((item) => item.code)
        .join(" , ");
    },
    getWoCodes(tr) {
      return tr.work_orders.map((item) => item.work_order_code).join(" , ");
    },
    getWoCodes(tr) {
      return tr.work_orders.map((item) => item.work_order_code).join(" , ");
    },
    getTastePanelStatus(tr) {
      return tr.status != null ? tr.status : 'Pending'
    },
    filterQueryUpdate() {
      this.getTestGroupList();
    },
    handleChangePage(page) {
      this.page = page;
      this.getTestGroupList();
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index];
    },
    onCLickCreateTestPanel() {
      this.$refs.tastingGroupCreate.openPopup();
    },
    onCLickCreateTestPanelwithCode(code = null, type = null) {
      this.$refs.tastingGroupCreate.openPopup(null, code, type);
    },
    onCLickViewTestPanel(id) {
      this.$refs.tastingGroupCreate.openPopup(id);
    },
  },
  watch: {
    page() {
      this.getTestGroupList();
    },
    perPage() {
      this.getTestGroupList();
    },
  },
};
</script>
